import React, { useEffect, useState } from 'react'
import { contentService } from '../../../../services/content.service'
import { FALLBACK_VENUES, FEATURED_VENUES_LIMIT, VenueCardData, toVenueCardData } from '../data/venues'
import { useScrollReveal } from '../hooks/useScrollReveal'
import VenueCard from './VenueCard'

const AroundChicagoSection: React.FC = () => {
  const { ref, visible } = useScrollReveal<HTMLDivElement>()
  // null while loading: render placeholders of the same size so the grid doesn't jump.
  const [venues, setVenues] = useState<VenueCardData[] | null>(null)

  useEffect(() => {
    let cancelled = false
    contentService
      .getFeaturedVenues(FEATURED_VENUES_LIMIT)
      .then(result => {
        if (!cancelled) setVenues(result.length > 0 ? result.map(toVenueCardData) : FALLBACK_VENUES)
      })
      .catch(error => {
        console.error('Loading featured venues failed:', error)
        if (!cancelled) setVenues(FALLBACK_VENUES)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const cards: Array<VenueCardData | undefined> = venues ?? Array.from({ length: FEATURED_VENUES_LIMIT }, () => undefined)

  return (
    <section id="around-chicago" className="v2-section v2-section--chicago">
      <div className="v2-container v2-chicago-head">
        <div>
          <p className="v2-eyebrow v2-eyebrow--mint">Out in Chicago</p>
          <h2 className="v2-section-title">Where will you meet?</h2>
        </div>
        <p className="v2-chicago-blurb">Coffee, a workout, a walk in the park, or a drink with friends. Open the map and see who’s out.</p>
      </div>

      <div ref={ref} className={`v2-container v2-chicago-grid v2-reveal ${visible ? 'is-visible' : ''}`}>
        {cards.map((venue, index) => (
          <VenueCard key={venue?.key ?? `placeholder-${index}`} venue={venue} style={visible ? { transitionDelay: `${index * 70}ms` } : undefined} />
        ))}
      </div>
    </section>
  )
}

export default AroundChicagoSection
